const modes = {
  before: "before",
  prep: "prep",
  answering: "answering",
  finished: "finished"
};

export {modes};